import { createContext } from "react";

export type SeoRenderData = {
  title: string;
  description: string;
  canonicalUrl: string;
  keywords?: string;
  robots: string;
  image: string;
  siteName: string;
  ogType: "website" | "article" | "product";
  twitterCard: "summary" | "summary_large_image";
};

export type SeoRenderCollector = {
  current: SeoRenderData | null;
};

export const SeoRenderContext = createContext<SeoRenderCollector | null>(null);
